// CSS
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/theme.css';
import "./scss/index.scss";

// JS
import jQuery from "jquery";
import * as lodash from 'lodash-es';
import "broadcastchannel-polyfill";
import "@popperjs/core";
import "./js/libs/md5.js";
import "jquery-mask-plugin";
import "jquery-form";
import "jssor-slider";
import "slick-carousel";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import {
    Alert,
    Button,
    Carousel,
    Collapse,
    Dropdown,
    Modal,
    Offcanvas,
    Popover,
    ScrollSpy,
    Tab,
    Toast,
    Tooltip
} from "bootstrap";
import "./js/functions.js";
import "./js/pk.js";
import "./js/polkurier-alertify.js";
import "./js/polkurier-select2.js";
import {map, css, html, LitElement, unsafeHTML, unsafeCSS, ref, classMap, styleMap, defaultConverter, repeat} from '../../admin/script/libs/lit.dist.js';

// jQueryUI
import {initDatepickerPair} from "./js/polkurier-date-picker.js";
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-serializejson';

// Polkurier
import {getTooltip, hideTooltips, initTooltips} from "./js/polkurier-tooltip.js";
import {
    disposePopover,
    getPopover,
    hidePopover,
    initPopover,
    setPopoverContent,
    showPopover
} from "./js/polkurier-popover.js";
import {store, Store} from "../../admin/script/store.js";
import {EventsEmitter, triggerStateChangeEvents} from "../../admin/script/events-emitter.js";
import {formDataToJson, getBlob} from '../../admin/script/util/http.js';
import {param} from '../../admin/script/util/param.js';
import {
    createSpinner,
    getSpinner,
    removeSpinner,
    setButtonBusyState,
    showSpinner,
    unsetButtonBusyState
} from "./js/spinners.js";
import {bindCheckboxesGroup} from "../util/browser/bind-checkboxes-group.js";
import {httpDelete, httpGet, httpPost, httpPostFormData, httpPut, GET, POST, PUT, DELETE} from "../util/http.js";
import {restGet, restPost, restPut, restDelete, restSaveModel} from "../../admin/script/util/http.js";
import {parseQueryString, Paths, Path, Url} from "../util/url.js";
import {createTimedPulseAnimation} from "../util/animations.js";
import {includes, pluck} from "../util/collections.js";
import {
    bytesToUnit,
    formatCurrency,
    formatIban,
    formatNumber,
    formatPhoneNumber,
    numberFilter,
    unitToBytes
} from "../util/number.js";
import {invert} from "../util/object.js";
import {getViewportSize, copyToClipboard, getEventPosition, getMatchingElementOrParent, isOrHasParent, cancelDomEvent, downloadFile, downloadFileBlob, downloadPdf, downloadFileBase64} from "../../admin/script/util/browser.js";
import {downloadUrlFile} from "../util/browser/download-url-file.js";
import {editDistance, isEmailAddress, removeNonASCIICharacters, similarText} from "../util/strings.js";
import {appendFileName, randomPassword, randomString} from "../../admin/script/util/string.js";
import {LoadingDialog} from "./js/dialogs/loading-dialog.js";
import {Dialog} from "../util/dialogs.js";
import {confirm} from "./js/dialogs/confirm.js";
import {showLoginDialog} from './js/dialogs/login-dialog.js';
import {
    showErrorPopup,
    addValidationError,
    clearValidationErrors,
    flattenValidationErrors,
    mergeValidationErrors,
    showValidationErrors,
    hasValidationErrors,
    convertAjaxResponseErrorMessageToString,
    convertAjaxResponseErrorToValidationErrors
} from "../util/errors.js";
import {
    validateBankNumber,
    validateEmail,
    validateIdentityNumber,
    validateNipNumber,
    validatePeselNumber,
    validatePhoneNumber,
    validatePostalCode,
    validateRegonNumber
} from "../../admin/script/util/validator.js";
import browserFingerprint from "./js/libs/browser-fingerprint.js";
import {remove as removeDiacritics} from 'diacritics';
import {SmsCounter} from './js/libs/sms-counter.js';
import {
    DAY,
    HOUR,
    MINUTE,
    MONTH,
    SECOND, UNIX_DAY,
    UNIX_HOUR,
    UNIX_MINUTE, UNIX_MONTH,
    UNIX_SECOND, UNIX_WEEK, UNIX_YEAR,
    WEEK,
    YEAR,
    secondsToTime,
} from "../../admin/script/util/time.js";
import "./js/file-select.js";
import {Chat} from './chat/chat.js';
import {ContactController} from "./contact-controller/contact-controller.js";
import {formatDate} from '../util/datetime.js';
import {CodStatisticsView} from "./dashboard/cod-statistics-view.js";
import {RegisterForm} from "./js/register-form.js";
import {RegisterWrForm} from "./js/register-wr-form.js";
import {SettingsStorage} from "../util/browser/settings-storage.js";
import {CollapseWithStorage} from "../util/browser/collapse-with-storage.js";
import {TakePhotoModal} from "./js/take-photo-modal.js";
import {Confetti} from "./js/libs/confetti.js";
import {evaluateLogicCondition} from "../../admin/script/util/logic.js";
import {evaluateFormLogic} from "../../admin/script/util/form-logis.js";
import {createToast, createSuccessToast, createInfoToast, createWarningToast, createErrorToast, removeToastMessage, updateToastMessage} from '../../admin/script/toast-messages/toast-messages.js';
import {TOAST_TYPE_INFO, TOAST_TYPE_SUCCESS, TOAST_TYPE_DANGER, TOAST_TYPE_WARNING} from '../../admin/script/toast-messages/toast-messages-config.js';
import {showAlertToasts, errorAlert, successAlert, errorAlerts, successAlerts} from "../../admin/script/alerts.js";

// Custom elements
import '../components/pk-star-rating.js';
import '../components/pk-taggable-text-editor.js';
import '../components/pk-file-input.js';
import '../components/pk-show-password.js';
import '../components/pk-corner-ribbon.js';
import '../components/pk-show-more.js';
import '../../admin/script/custom-elements/pk-copy-button.js';
import '../../admin/script/custom-elements/pk-sortable.js';
import '../../admin/script/custom-elements/pk-editor.js';
import '../../admin/script/custom-elements/pk-text-counter.js';
import '../../admin/script/custom-elements/pk-stepper.js';
import '../../admin/script/custom-elements/pk-alert.js';
import '../../admin/script/custom-elements/pk-live-toggle.js';
import {PkToggle} from '../../admin/script/custom-elements/pk-toggle.js';
import {PkTooltipIcon} from '../../admin/script/custom-elements/pk-tooltip-icon.js';
import {PkCopyBadge} from '../../admin/script/custom-elements/pk-copy-badge.js';
import {PkToastMessage} from '../../admin/script/custom-elements/pk-toast-container.js';
import {createConfirm, createAlert} from '../../admin/script/custom-elements/pk-alert-dialog.js';
import {toggleButtonBusyState} from '../../admin/script/custom-elements/pk-spinner.js';

PkToastMessage.defaultIconType = 'solid';
PkToastMessage.defaultSuccessIcon = 'fa-check';
PkToastMessage.defaultSuccessIconType = PkToastMessage.defaultIconType;
PkToastMessage.defaultWarningIconType = PkToastMessage.defaultIconType;

PkCopyBadge.defaultIconType = '';
PkCopyBadge.defaultIconCollection = 'bi';
PkCopyBadge.defaultIcon = 'copy';

PkToggle.wrapperClassName = 'form-check form-switch';
PkToggle.inputClassName = 'form-check-input';
PkToggle.labelClassName = 'form-check-label';

PkTooltipIcon.defaultIconCollection = 'bi';
PkTooltipIcon.defaultIcon = 'question-circle';

window.jQuery = jQuery;
window.$ = jQuery;
window._ = lodash;

window.POLKURIER = {
    ...(window.POLKURIER || {}),
    ENVIRONMENT: 'FRONT',
    FA_ICON_TYPE: 'fa',
    supportsMediaQueries: typeof window.matchMedia === 'function',
    Store,
    store,
    EventsEmitter,
    triggerStateChangeEvents,
    events: new EventsEmitter(),
    paths: Paths.factory((window.POLKURIER || {}).paths),
    lit: {
        map,
        css,
        html,
        LitElement,
        unsafeHTML,
        unsafeCSS,
        ref,
        classMap,
        styleMap,
        defaultConverter,
        repeat,
    },

    // Tooltips
    getTooltip,
    initTooltips,
    hideTooltips,

    // Popovers
    initPopover,
    hidePopover,
    disposePopover,
    showPopover,
    getPopover,
    setPopoverContent,

    // Spinners
    toggleButtonBusyState,
    setButtonBusyState,
    unsetButtonBusyState,
    getSpinner,
    createSpinner,
    showSpinner,
    removeSpinner,

    // Date / Time Tools
    formatDate,
    secondsToTime,
    initDatepickerPair,
    TIME: {
        SECOND,
        MINUTE,
        HOUR,
        DAY,
        WEEK,
        MONTH,
        YEAR,
        UNIX_SECOND,
        UNIX_MINUTE,
        UNIX_HOUR,
        UNIX_DAY,
        UNIX_WEEK,
        UNIX_MONTH,
        UNIX_YEAR,
    },

    // Ajax / HTTP Tools
    GET,
    POST,
    PUT,
    DELETE,
    httpGet,
    httpPost,
    httpPut,
    httpDelete,
    httpPostFormData,
    formDataToJson,
    param,
    getBlob,
    restGet,
    restPost,
    restPut,
    restDelete,
    restSaveModel,

    // URL / Paths Tools
    Url,
    Path,
    Paths,
    parseQueryString,
    parseUrl: url => Url.parse(url),
    generatePathUrl: (path, params) => Paths.generatePathUrl(path, params),

    // Collections / Arrays Tools
    includes,
    pluck,

    // Numbers Tools
    numberFilter,
    formatNumber,
    formatCurrency,
    formatPhoneNumber,
    formatIban,
    bytesToUnit,
    unitToBytes,

    // Objects Tools
    invert,

    // Strings Tools
    removeNonASCIICharacters,
    similarText,
    editDistance,
    isEmailAddress,
    removeDiacritics,
    SmsCounter,
    appendFileName,
    randomString,
    randomPassword,

    // Misc browser tools
    browserFingerprint,
    copyToClipboard,
    getViewportSize,
    copyTextToClipboard: copyToClipboard,
    SettingsStorage,
    CollapseWithStorage,
    getEventPosition,
    getMatchingElementOrParent,
    isOrHasParent,
    cancelDomEvent,
    downloadFile,
    downloadPdf,
    downloadFileBlob,
    downloadFileBase64,
    downloadUrlFile,
    bindCheckboxesGroup,

    // Logic
    evaluateLogicCondition,
    evaluateFormLogic,

    // Validators
    validateBankNumber,
    validateIdentityNumber,
    validatePeselNumber,
    validateNipNumber,
    validatePhoneNumber,
    validatePostalCode,
    validateRegonNumber,
    validateEmail,

    // Error handling
    addValidationError,
    flattenValidationErrors,
    mergeValidationErrors,
    showValidationErrors,
    clearValidationErrors,
    hasValidationErrors,
    showErrorPopup,
    convertAjaxResponseErrorMessageToString,
    convertAjaxResponseErrorToValidationErrors,

    // Dialogs / Modals / Confirms
    confirm,
    Dialog,
    LoadingDialog,
    TakePhotoModal,
    showLoginDialog,
    errorAlert,
    errorAlerts,
    successAlert,
    successAlerts,
    createConfirmDialog: createConfirm,
    createAlertDialog: createAlert,
    createToast: createToast,
    createSuccessToast: createSuccessToast,
    createInfoToast: createInfoToast,
    createWarningToast: createWarningToast,
    createErrorToast: createErrorToast,
    removeToastMessage: removeToastMessage,
    updateToastMessage: updateToastMessage,
    showAlertToasts: showAlertToasts,
    TOAST_TYPE_INFO: TOAST_TYPE_INFO,
    TOAST_TYPE_SUCCESS: TOAST_TYPE_SUCCESS,
    TOAST_TYPE_DANGER: TOAST_TYPE_DANGER,
    TOAST_TYPE_WARNING: TOAST_TYPE_WARNING,

    // Animations
    createTimedPulseAnimation,
    Confetti,

    // Other
    RegisterForm,
    RegisterWrForm,
    Chat,
    ContactController,
    CodStatisticsView,
};

// Bootstrap components
window.bootstrap = {
    Alert,
    Button,
    Carousel,
    Collapse,
    Dropdown,
    Modal,
    Offcanvas,
    Popover,
    ScrollSpy,
    Tab,
    Toast,
    Tooltip,
};
